<template>
    <div class="q-pa-md">

        <q-form class="q-gutter-md row items-start" @submit="onSubmit" @reset="onReset">
            <div class="q-pa-md example-row-stacked-to-horizontal" style="width: 100%">
                <div class="row">
                    <q-input class="col-12 col-md-12 q-px-md" dense filled v-model="mqtt.host" label="Host" lazy-rules
                        :rules="[val => val && val.length > 0 || 'Please type host']" />
                </div>
                <div class="row">
                    <q-input class="col-12 col-md-8 q-px-md q-pb-md" dense filled v-model="mqtt.topic" label="Topic"
                        lazy-rules />
                    <q-toggle class="col-12 col-md-4 q-px-md q-pb-md" v-model="mqtt.options.clean" label="Clean Session" />
                </div>
                <div class="row">
                    <q-input class="col-12 col-md-4 q-px-md q-pb-md" dense filled v-model="mqtt.options.username" label="Username"
                        lazy-rules />
                    <q-input class="col-12 col-md-4 q-px-md q-pb-md" dense filled v-model="mqtt.options.password" label="Password"
                        lazy-rules />
                    <q-input class="col-12 col-md-4 q-px-md q-pb-md" dense filled v-model="mqtt.options.clientId" label="clientId"
                        lazy-rules />
                </div>
            </div>

            <div>
                <q-btn label="Save" type="submit" color="primary" />
                <q-btn label="Reset" type="reset" color="primary" flat class="q-ml-sm" />
            </div>
        </q-form>

    </div>
</template>
  
<style></style>
  
<script>
// import { ref } from 'vue'

export default {
    name: 'MQTTConfiguration',
    data() {
        return {
            mqtt: this.$store.getters.getMQTTConfig,

        }
    },
    mounted() {
    },
    methods: {
        onReset() {
            console.log("config reset", this.mqtt);
            this.$store.commit('resetMQTTConfig');
            this.mqtt = this.$store.getters.getMQTTConfig;
        },
        onSubmit() {
            console.log("config set", this.mqtt);
            let mqtt_config = Object.assign({}, this.mqtt);
            this.$store.commit('setMQTTConfig', mqtt_config);
        },
    }
}


</script>
  